import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Siren } from "lucide-react";
import { useLang } from "../i18n/LangContext";
import { useSettings } from "../context/SettingsContext";
import { serviceById } from "../data/services";
import { CallButton, PhoneSoonNote } from "../components/site/CallButton";
import { useSeo } from "../components/site/Seo";
import { CtaBand } from "./Home";
import NotFound from "./NotFound";

export default function ServicePage() {
  const { id } = useParams();
  const { t, lang } = useLang();
  const { settings, loaded } = useSettings();
  const svc = serviceById(id);
  const enabled = svc && (!loaded || settings.enabled_services.includes(id));
  const [name, desc] = svc ? t(`services.${id}`) : ["", ""];
  useSeo(
    `${name} in Houston, TX | ${settings.business_name}`,
    `${desc} ${lang === "es" ? "Solicite ayuda en línea en Houston, Texas." : "Request help online in Houston, Texas."}`
  );
  if (!enabled) return <NotFound />;
  const Icon = svc.icon;
  return (
    <>
      <section className="relative isolate overflow-hidden border-b border-[#2E2E3A]">
        <img src={svc.tow ? "/images/hero.webp" : "/images/roadside.webp"} alt={svc.tow ? t("hero.imageAlt") : "Roadside technician helping a driver on a road shoulder"} className="absolute inset-0 -z-10 h-full w-full object-cover opacity-30" />
        <div className="container-x py-16 sm:py-24">
          <Link to="/#services" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white" data-testid="service-page-back"><ArrowLeft className="h-4 w-4" /> {t("nav.services")}</Link>
          <div className="mt-6 flex h-14 w-14 items-center justify-center rounded-xl bg-[#DC2626] text-white"><Icon className="h-7 w-7" aria-hidden="true" /></div>
          <h1 data-testid="service-page-title" className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight">{name}</h1>
          <p className="mt-2 text-lg font-semibold text-[#FACC15]">Houston, Texas</p>
          <p className="mt-4 max-w-2xl text-lg text-gray-300">{desc}</p>
          <p className="mt-2 max-w-2xl text-gray-400">{t("hero.note")}</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to={`/request?service=${id}`} className="btn-red px-8 py-4" data-testid="service-page-request-btn"><Siren className="h-5 w-5" /> {t("cta.requestService")}</Link>
            <CallButton testId="service-page-call-btn" className="px-8 py-4" />
          </div>
          <div className="mt-3"><PhoneSoonNote testId="service-page-phone-soon" /></div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
